<div class="container">
  <app-header [today]="today"></app-header>
  <section class="main-container">
    <div
      class="row"
      *ngFor="let habit of habits$ | async | keyvalue; trackBy: trackByFn"
    >
      <app-habit
        [habit]="habit.value"
        (habitTap)="addStrikeToHabit(habit.value)"
        (delete)="deleteHabit(habit.value)"
        (habitPress)="removeStrikeToHabit(habit.value)"
      ></app-habit>
    </div>
  </section>

  <nav class="error" *ngIf="form.controls.habit.errors && form.touched">
    <div class="error__message" *ngIf="form.controls.habit.errors?.required">
      Habit name is required
    </div>

    <div class="error__message" *ngIf="form.controls.habit.errors?.habitExist">
      Habit exist
    </div>

    <div class="error__close" (click)="closeErrorBar()">x</div>
  </nav>
  <nav class="footer">
    <form class="form" [formGroup]="form">
      <div class="input">
        <input class="input__box" type="text" formControlName="habit" />
      </div>
      <button class="form__button" (click)="addHabit()">➕️</button>
    </form>

    <button class="config-button" (click)="openConfig()">🛠️</button>
  </nav>
</div>

<div #modal></div>
